import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SiteSpecificConstraints = () => {
  const knowledgeBases = [
    {
      title: "Site Analysis and Constraints Database",
      description: "Comprehensive database of site-specific constraints for federal properties nationwide",
      type: "Database",
      lastUpdated: "2024-02-22"
    },
    {
      title: "Geotechnical Constraints Assessment",
      description: "Tools and methodologies for assessing geotechnical constraints in federal site development",
      type: "Assessment",
      lastUpdated: "2024-01-30"
    },
    {
      title: "Environmental Impact Considerations",
      description: "Framework for evaluating and managing environmental constraints in federal construction",
      type: "Framework",
      lastUpdated: "2024-02-14"
    },
    {
      title: "Zoning and Land Use Compliance Tools",
      description: "Tools for ensuring federal projects comply with local zoning and land use requirements",
      type: "Tool",
      lastUpdated: "2024-02-08"
    },
    {
      title: "Utilities and Infrastructure Mapping",
      description: "Comprehensive mapping and analysis of existing utilities and infrastructure constraints",
      type: "Mapping",
      lastUpdated: "2024-02-16"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Site-Specific Constraints Management</h1>
          <p className="text-muted-foreground">
            Tools and knowledge bases for identifying, analyzing, and managing site-specific constraints in federal building projects.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm">
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SiteSpecificConstraints;